import axiosInstance from '@/services/axiosInstance'

async function getNews () {
  const req = {
    url: 'api/usuarios/getbannernoticias',
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    }
  }
  const res = await axiosInstance(req)
  return res.data
}

export { getNews }
